class CatalogTypes {
	static get FOLDER() {
		return 'Folder';
	}
	static get MAP() {
		return 'map';
	}
	static get LAYER() {
		return 'Layer';
	}
}

export default CatalogTypes;